module.exports = __webpack_public_path__ + "img/autoprod-1.4dcd5601.jpg";